<p> change-antibiogramm-client-dialog works! </p>
